(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.ugc-gallery__wrapper');
  if (!wrapper) return; // Added safety check

  const desktopCols = parseInt(wrapper.dataset.desktopCols, 10) || 3;
  const dotsContainer = document.querySelector('.ugc-gallery__pagination');
  const videos = wrapper ? wrapper.querySelectorAll('.ugc-gallery__video') : [];
  const nav = document.querySelector('.ugc-gallery__nav');
  const prevBtn = document.querySelector('.ugc-gallery__prev');
  const nextBtn = document.querySelector('.ugc-gallery__next');

  if (!wrapper || videos.length === 0) return;

  // Slider for desktop if > desktopCols (was > 5)
  if (videos.length > desktopCols) {
    wrapper.classList.add('has-slider');
    nav.style.display = 'flex';
  }

  // Pagination dots
  if (dotsContainer) {
    videos.forEach((_, i) => {
      const dot = document.createElement('span');
      dot.className = 'ugc-gallery__pagination-dot';
      if (i === 0) dot.classList.add('active');
      dotsContainer.appendChild(dot);
    });
  }
  const dots = dotsContainer ? dotsContainer.querySelectorAll('.ugc-gallery__pagination-dot') : [];

  const updateActiveDot = () => {
    const wrapperRect = wrapper.getBoundingClientRect();
    let closestIndex = 0;
    let closestDistance = Infinity;
    videos.forEach((video, i) => {
      const rect = video.getBoundingClientRect();
      const distance = Math.abs(rect.left - wrapperRect.left);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = i;
      }
    });
    dots.forEach(dot => dot.classList.remove('active'));
    if (dots[closestIndex]) dots[closestIndex].classList.add('active');
  };
  wrapper.addEventListener('scroll', updateActiveDot);

  // Arrow navigation
  if (nav && prevBtn && nextBtn) {
    prevBtn.addEventListener('click', () => {
      wrapper.scrollBy({ left: -wrapper.clientWidth, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      wrapper.scrollBy({ left: wrapper.clientWidth, behavior: 'smooth' });
    });
  }

  // Play/Pause toggle + Mute toggle
  videos.forEach(videoDiv => {
    const video = videoDiv.querySelector('video');
    const playBtn = videoDiv.querySelector('.ugc-gallery__play-btn');
    const muteBtn = videoDiv.querySelector('.ugc-gallery__mute-btn');

    // Video starts autoplay muted, play icon hidden initially
    playBtn.style.display = 'none';
    video.muted = true;
    video.play();

    const togglePlay = () => {
      if (video.paused) {
        video.play();
        playBtn.style.display = 'none';
      } else {
        video.pause();
        playBtn.style.DIsplay = 'block';
      }
    };

    // Click on play button or video toggles play/pause
    playBtn.addEventListener('click', togglePlay);
    video.addEventListener('click', togglePlay);

    // Mute toggle (does not pause video)
    muteBtn.addEventListener('click', () => {
      video.muted = !video.muted;
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
